<template>
  <v-footer height="auto">
    <div class="footer">
      <div class="footer-container">
        <div class="footer-content">
          <div class="footer-label">Signal</div>
          <div class="link" @click="windowOpen('https://signal.oopy.io')">회사 소개</div>
          <div class="link" @click="windowOpen('https://www.signal.bz/news/tip')">서비스 소개</div>
          <div class="link" @click="windowOpen('https://signal.oopy.io/2cbd22ce-3e02-4158-8bf8-c591747b58ba')">업데이트소식</div>
        </div>
        <div class="footer-content">
          <div class="footer-label">Legal</div>
          <div class="link" @click="route('terms')">서비스 이용약관</div>
          <div class="link" @click="route('privacy')">개인정보 처리방침</div>
        </div>
        <div class="footer-content">
          <div class="footer-label">Support</div>
          <div style="padding: 5px">문의</div>
          <a class="link" href="mailto: mysignal.bob@gmail.com">mysignal.bob@gmail.com</a>
        </div>
        <div class="footer-content" style="display: flex; align-items: center">
          <div class="sns-icon-bg" @click="windowOpen('https://www.youtube.com/channel/UCz8fQdHImw3Ikm_KnxOanrA')">
            <img loading="lazy" class="sns-icon" src="../assets/img/common/sns/youtube.svg" />
          </div>
          <div class="sns-icon-bg" @click="windowOpen('https://www.tiktok.com/@signallab_news')">
            <img loading="lazy" class="sns-icon" src="../assets/img/common/sns/tiktok.svg" />
          </div>
          <div class="sns-icon-bg" @click="windowOpen('https://www.instagram.com/signallab_news')">
            <img loading="lazy" class="sns-icon" src="../assets/img/common/sns/instagram.svg" />
          </div>
          <div class="sns-icon-bg" @click="windowOpen('https://twitter.com/Signallab_news')">
            <img loading="lazy" class="sns-icon" src="../assets/img/common/sns/twitter.svg" />
          </div>
          <div class="sns-icon-bg" @click="windowOpen('https://www.facebook.com/signalissue')">
            <img loading="lazy" class="sns-icon" src="../assets/img/common/sns/facebook.svg" />
          </div>
        </div>
      </div>
      <div class="footer-desc">
        <div style="display: flex; align-items: center">
          <img
            loading="lazy"
            class="logo-signal-mono"
            src="../assets/img/common/logo-signal-mono.svg"
            alt="logo-signal-mono"
          />&nbsp;&nbsp;(주)시그널랩
        </div>
        <div style="padding: 5px">
          <div>시그널은 원하는 소식을 가장 빠르고 정확하게 전달해드립니다.</div>
          <div class="mt5">서울시 서초구 강남대로 479 피치트리</div>
        </div>
      </div>
    </div>
  </v-footer>
</template>
<script>
export default {
  methods: {
    route(name) {
      this.$router.push({ name })
    },
    windowOpen(url) {
      window.open(url, "_blank")
    }
  }
}
</script>
<style lang="scss" scoped>
$highlight-color: rgba(8, 6, 23, 0.145);
.footer {
  width: 100%;
  background-color: #393f45;
  padding: 20px 20px 40px 20px;
  color: #eef0f2;
  font-size: 14px;
  @include desktop {
    font-size: 16px;
  }

  .footer-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    @include mobile {
      flex-direction: column;
    }
    @include desktop {
      flex-wrap: nowrap;
    }

    .footer-content {
      padding: 10px 0;

      @include desktop {
        padding: 0;
      }

      &:not(:last-child) {
        width: 33%;
      }
    }

    .link {
      cursor: pointer;
      padding: 3px 5px;
      border-radius: 4px;
      color: white !important;
      text-decoration: none;
      white-space: nowrap;
      &:hover {
        background: $highlight-color;
      }
    }

    .footer-label {
      margin: 2px 0;
      font-weight: bold;
      @include desktop {
        font-size: 18px;
        margin: 10px 0;
      }
    }

    .sns-icon-bg {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 35px;
      height: 35px;
      cursor: pointer;
      margin: 2px;
      background-color: $highlight-color;
      border-radius: 50%;

      @include desktop {
        width: 45px;
        height: 45px;
      }

      .sns-icon {
        width: 25px;
        height: 25px;

        @include desktop {
          width: 30px;
          height: 30px;
        }
      }
    }
  }
  .footer-desc {
    border-top: 1px solid #eef0f2;
    padding-top: 20px;
    margin-top: 20px;

    @include desktop {
      padding-top: 30px;
      margin-top: 30px;
    }

    .logo-signal-mono {
      width: 80px;
      @include desktop {
        width: 100px;
      }
    }
  }
}
</style>
